import React from "react";
import "../styles/Events.css";
import EventCard from "./Reusable/EventCard";
import event1 from "../images/machine-learning.jpg";
import event2 from "../images/python.jpg";
import event3 from "../images/django.jpg";

const events = [
  {
    collegeName: "Atharva College of Engineering.",
    image: event1,
    speaker: " Nilesh Shinde",
    speakerLink: "https://www.instagram.com/nilexshinde/",
    dateAndDay: "Tuesday, 27th August, 2019",
    workshopTopic: "Machine Learning"
  },
  {
    collegeName: "M.H Saboo Siddik Polytechnic.",
    image: event2,
    speaker: " Ehtesham Siddiqui",
    speakerLink: "https://www.linkedin.com/in/siddiquiehtesham/",
    dateAndDay: "Saturday, 31st August, 2019",
    workshopTopic: "Python Programming"
  },
  {
    collegeName: "SIES Graduate School, Nerul",
    image: event3,
    speaker: " Ehtesham Siddiqui",
    speakerLink: "https://www.linkedin.com/in/siddiquiehtesham/",
    dateAndDay: "Saturday, 7th September, 2019",
    workshopTopic: "Django Framework"
  }
];

export default function Events() {
  return (
    <div className="p-3 main" id="events">
      <h3>Our Events.</h3>
      <div className="row text-center">
        {events.map(function(event, index) {
          return (
            <div className="col-sm-12 col-md-12 col-xl-4 m-0 mt-5" key={index}>
              <EventCard
                image={event.image}
                collegeName={event.collegeName}
                dateAndDay={event.dateAndDay}
                speaker={event.speaker}
                topic={event.workshopTopic}
                speakerLink={event.speakerLink}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
